import React, { useEffect, useState } from 'react';
import api from 'helpers/api';
import {
  getIdEmpresa,
  setExisteImportacao,
  setExisteExportacao,
  setExisteEmbarque,
  getIdUsuario,
  setOperacaoLocal,
  getOperacaoLocal
} from 'helpers/auth';
import { Card, Row, Col, Form, Spinner } from 'react-bootstrap';
import 'assets/scss/grids.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PageHeader from 'components/common/PageHeader';
import Operations from './Operations';
import PrevisaoChegada from './PrevisaoChegada';
import DeadLine from './DeadLine';
import AtividadesRecentes from './AtividadesRecentes';
import AtividadesRecentesEmbarque from './AtividadesRecentesEmbarque';
import ControleCanal from './ControleCanal';
import FilterDate from './FilterDate';
import TransitTime from './TransitTime';
import IconButton from 'components/common/IconButton';
import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import { useDashboard } from './DashboardContext';
import Flex from 'components/common/Flex';
import Demurrage from './Demurrage';
import TotalImporter from './TopImporter';
import TopFaturamento from './TopFaturamento';
import TopModalidade from './TopModalidade';

const Dashboard = () => {
  const [tipoOperacoes, setTipoOperacoes] = useState([]);
  const [dataLastEvents, setLastEvents] = useState([]);
  const [dataLastEventsExDesemb, setLastEventsExDesemb] = useState([]);
  const [dataLastEventsExEmb, setLastEventsExEmb] = useState([]);
  const [dataPrevChegada, setPrevChegada] = useState([]);
  const [deadLineCarga, setDeadLineCarga] = useState([]);
  const [deadLineDoc, setDeadLineDoc] = useState([]);
  const [dataCanais, setDataCanais] = useState([]);
  const [dataSituacoes, setSituacoes] = useState([]);
  const [dataOrigensGraph, setOrigensGraph] = useState([]);
  const [dataTopExportadores, setTopExportadores] = useState({
    importers: [],
    values: [],
    valoresConvertidos: []
  });
  const [dataTopImportadores, setTopImportadores] = useState({
    importers: [],
    values: [],
    valoresConvertidos: []
  });
  const [dataTopFaturamento, setTopFaturamento] = useState({
    meses: [],
    values: [],
    valoresConvertidos: []
  });
  const [dataTopModalidade, setTopModalidade] = useState([]);
  const [embarquesModal, setEmbarquesModal] = useState([]);
  const [modalidades, setModalidades] = useState([]);
  const [dataFiles, setDataFiles] = useState([]);
  const [dataControleCanal, setDataControleCanal] = useState([]);
  const [dataLeadTime, setDataLeadTime] = useState([]);
  const [transitTime, setTransitTime] = useState(0);
  const [canaisTotal, setCanaisTotal] = useState(0);
  const [qtdSituacoes, setQtdSituacoes] = useState(0);
  const [mediaRegistro, setMediaRegistro] = useState(0);
  const [mediaLiberacao, setMediaLiberacao] = useState(0);
  const [realizouConsulta, setRealizouConsulta] = useState(false);
  const [realizouConsultaDados, setRealizouConsultaDados] = useState(false);
  const [existeFrete, setExisteFrete] = useState(false);
  const [existeAtividade, setExisteAtividade] = useState(false);
  const [filterPeriodo, setFilterPeriodo] = useState(
    'p.dat_abertura >= CURDATE() - INTERVAL 180 DAY'
  );
  const [filterPeriodoOrigem, setFilterPeriodoOrigem] = useState(
    'p.dat_embarque >= CURDATE() - INTERVAL 180 DAY'
  );
  const [filterRegistroDI, setFilterRegistroDI] = useState(
    ' dat_registro_di >= CURDATE() - INTERVAL 180 DAY'
  );
  const [filterTopExportadores, setFilterTopExportadores] = useState(
    'p.dat_faturamento >= CURDATE() - INTERVAL 180 DAY'
  );
  const [filterTopImportadores, setFilterTopImportadores] = useState(
    'p.dat_emissao_nf >= CURDATE() - INTERVAL 180 DAY'
  );
  const [nameOperacao, setNameOperacao] = useState('');
  const [filterOperacao, setFilterOperacao] = useState('');
  const [filterModalidade, setFilterModalidade] = useState(null);
  const [filterModalidadeSub, setFilterModalidadeSub] = useState(null);
  const { selectedId, setSelectedId } = useDashboard();
  const [dataMoedas, setDataMoedas] = useState([]);
  const [dateRange, setDateRange] = useState({
    startDate: null,
    endDate: null
  });

  useEffect(() => {
    const today = new Date();
    const pastDate = new Date(today);
    pastDate.setDate(today.getDate() - 180);

    setDateRange({
      startDate: pastDate,
      endDate: today
    });
    if (getIdUsuario() === null) {
      window.location.href = '/';
    }

    if (getIdEmpresa() > 0) {
      fetchDados();
      // getEmbarqueAeroporto()
    }
  }, []);

  const fetchDados = async () => {
    setRealizouConsulta(false);
    setRealizouConsultaDados(false);
    const getCanais = async () => {
      const result = await api.post('/api/indicadores/', {
        companyId: getIdEmpresa(),
        operacao: getOperacaoLocal(),
        filter: filterRegistroDI,
        filterSub: filterRegistroDI
      });
      const data = result.data.data;
      if (data.length > 0) {
        setDataCanais(data);
        setCanaisTotal(data[0].total_geral);
      }

      const resultSituacao = await api.post('/api/situacoes/', {
        companyId: getIdEmpresa(),
        operacao: getOperacaoLocal(),
        filter: filterPeriodo
      });
      setSituacoes(resultSituacao.data.data);
      setQtdSituacoes(resultSituacao.data.total);
      if (getOperacaoLocal() !== '') {
        const resultOrigensGraph = await api.post('/api/origens/', {
          companyId: getIdEmpresa(),
          operacao: getOperacaoLocal(),
          filter: filterPeriodoOrigem
        });
        setOrigensGraph(resultOrigensGraph.data.data);
      }
    };

    const getMoedas = async () => {
      let filtro = '';

      filtro = '';
      if (getOperacaoLocal() !== 'EXPORTAÇÃO') {
        filtro =
          " where m.datataxa  = CURDATE() and m.MoedaId IN('EUR', 'US$')";
      } else {
        filtro =
          " where m.datataxa  = CURDATE() - INTERVAL 1 DAY and m.MoedaId IN('EUR', 'US$')";
      }

      const result = await api.post('/api/moedas', { filtro });
      if (result.data.length > 0) {
        setDataMoedas(result.data.result);
        // if (result.data.result[0]['ptaxcompravalor'] === null) {
        //   // Chama o backend para buscar dados dos últimos 5 dias em uma única requisição
        //   const diasResultados = await api.post('/api/moedas/ultimos-dias', { moedaIds: ['EUR', 'US$'], dias: 5 });
        //   setDataMoedas(diasResultados.data.result);
        // } else {

        // }
      } else {
        const diasResultados = await api.post('/api/moedas/ultimos-dias', {
          moedaIds: ["'EUR'", "'US$'"],
          dias: 5
        });
        setDataMoedas(diasResultados.data.result);
      }
    };

    const getMedias = async () => {
      let filterOp =
        getOperacaoLocal() === 'EXPORTAÇÃO'
          ? filterTopExportadores
          : filterTopImportadores;
      try {
        const resultInd = await api.post('/api/indicadoresMedias/', {
          companyId: getIdEmpresa(),
          operacao: getOperacaoLocal(),
          filter: filterOp
        });
        const dataInd = resultInd.data || {};

        const operacao = getOperacaoLocal();
        if (operacao === 'EXPORTAÇÃO') {
          setMediaRegistro(dataInd?.mediaregistro ?? 0);
          setMediaLiberacao(dataInd?.liberacao?.mediaLib ?? 0);
        } else if (operacao === 'IMPORTAÇÃO') {
          const primeiroItem =
            Array.isArray(dataInd?.data) && dataInd.data.length > 0
              ? dataInd.data[0]
              : null;
          setMediaRegistro(primeiroItem?.leadtime ?? 0);
          setMediaLiberacao(primeiroItem?.registrodi ?? 0);
        } else if (operacao === 'AGENCIAMENTO') {
          setTransitTime(dataInd?.freetime ?? 0);
        }
      } catch (error) {
        setMediaRegistro(0);
        setMediaLiberacao(0);
        setTransitTime(0);
      }

      // const dataInd = resultInd.data;
      // if (getOperacaoLocal() === 'EXPORTAÇÃO') {
      //   setMediaRegistro(dataInd.mediaregistro);
      //   setMediaLiberacao(dataInd.liberacao.mediaLib);
      // } else if (getOperacaoLocal() === 'IMPORTAÇÃO') {
      //   // setMediaRegistro(dataInd.data[0].leadtime)
      //   // setMediaLiberacao(dataInd.data[0].registrodi)
      // } else if (getOperacaoLocal() === 'AGENCIAMENTO') {
      //   setTransitTime(dataInd.freetime);
      // }
    };

    const getTipoOperacoes = async () => {
      const result = await api.get('/api/tpoperacoes/' + getIdEmpresa());
      const data = result.data.data;
      if (data.length > 0) {
        setTipoOperacoes(data);
        localStorage.setItem('OPERACOES', JSON.stringify(data));
        for (let index = 0; index < data.length; index++) {
          if (data[index].operacao === 'AGENCIAMENTO') {
            setOperacaoLocal('AGENCIAMENTO');
            setFilterOperacao('AGENCIAMENTO');
            setNameOperacao('AGENCIAMENTO');
            setExisteFrete(true);
            setExisteEmbarque(true);
          }
          if (data[index].operacao === 'IMPORTAÇÃO') {
            setOperacaoLocal('IMPORTAÇÃO');
            setFilterOperacao('IMPORTAÇÃO');
            setNameOperacao('IMPORTAÇÃO');
            setExisteImportacao(true);
          }
          if (data[index].operacao === 'EXPORTAÇÃO') {
            setExisteExportacao(true);
            setOperacaoLocal('EXPORTAÇÃO');
            setFilterOperacao('EXPORTAÇÃO');
            setNameOperacao('EXPORTAÇÃO');
          }
        }

        if (nameOperacao !== '') {
          setSelectedId(nameOperacao);
        }
      }
    };

    const getLeadTime = async () => {
      const result = await api.post('/api/leadtime/', {
        companyId: getIdEmpresa(),
        operacao: getOperacaoLocal(),
        filter: filterTopExportadores
      });
      const data = result.data.data;
      if (data.length > 0) {
        setDataLeadTime(data);
      }
    };

    const getModalidades = async () => {
      const result = await api.get('/api/modalidades/' + getIdEmpresa());
      const data = result.data.data;
      if (data.length > 0) {
        setModalidades(data);
      }
    };

    const getLastEvents = async () => {
      if (
        getOperacaoLocal() === 'IMPORTAÇÃO' ||
        getOperacaoLocal() === 'AGENCIAMENTO'
      ) {
        const result = await api.post('/api/topFollowPG/', {
          companyId: getIdEmpresa(),
          operacao: getOperacaoLocal()
        });
        const data = result.data.data;

        if (data.length > 0) {
          setLastEvents(data);
          setExisteAtividade(true);
        }
        const resultDeadLineCarga = await api.get(
          '/api/demurrage/' + getIdEmpresa()
        );
        const deadLineCarga = resultDeadLineCarga.data.data;
        if (deadLineCarga.length > 0) {
          setDeadLineCarga(deadLineCarga);
          setExisteAtividade(true);
        }

        const resultControleCarga = await api.get(
          '/api/controlecanal/' + getIdEmpresa()
        );
        const controleCanal = resultControleCarga.data.result;
        if (controleCanal.length > 0) {
          setDataControleCanal(controleCanal);
        }

        const resultTopExporters = await api.post('/api/topExportadores/', {
          companyId: getIdEmpresa(),
          operacao: getOperacaoLocal(),
          filter: filterTopExportadores
        });

        const topExporters = resultTopExporters.data.data.filter(
          items => items.name !== null
        );
        setTopExportadores({
          importers: topExporters.map(item => item.exportador),
          values: topExporters.map(item => item.valor),
          valoresConvertidos: topExporters.map(item => item.valor_convertido)
        });

        const resultTopModalidades = await api.post('/api/topModalidades/', {
          companyId: getIdEmpresa(),
          operacao: getOperacaoLocal(),
          filter: filterPeriodoOrigem
        });
        setTopModalidade(resultTopModalidades.data.data);

        const resultFaturamentoMensal = await api.post('/api/fatMensalImpo/', {
          companyId: getIdEmpresa(),
          operacao: getOperacaoLocal(),
          filter: filterTopExportadores
        });

        const faturamentoMensal = resultFaturamentoMensal.data.data;
        setTopFaturamento({
          meses: faturamentoMensal.map(item => item.mes_abreviado),
          values: faturamentoMensal.map(item => item.valor),
          valoresConvertidos: faturamentoMensal.map(
            item => item.valor_convertido
          )
        });

        setExisteAtividade(true);
      } else if (getOperacaoLocal() === 'EXPORTAÇÃO') {
        const resultExpo = await api.post('/api/topFollowEx/', {
          companyId: getIdEmpresa(),
          operacao: getOperacaoLocal()
        });
        const dataExpoDesem = resultExpo.data.desembaraco;
        const dataExpoEmbarque = resultExpo.data.embarque;
        if (dataExpoDesem.length > 0) {
          setLastEventsExDesemb(dataExpoDesem);
          setLastEventsExEmb(resultExpo?.data ?? 0);
          setExisteAtividade(true);
        }
        if (dataExpoEmbarque.length > 0) {
          setLastEventsExEmb(dataExpoEmbarque);
          setExisteAtividade(true);
        }

        const resultTopImporters = await api.post('/api/topImportadores/', {
          companyId: getIdEmpresa(),
          operacao: getOperacaoLocal(),
          filter: filterTopImportadores
        });

        const topImporters = resultTopImporters.data.data;
        setTopImportadores({
          importers: topImporters.map(item => item.importador),
          values: topImporters.map(item => item.valor),
          valoresConvertidos: topImporters.map(item => item.valor_convertido)
        });

        const resultTopModalidades = await api.post('/api/topModalidades/', {
          companyId: getIdEmpresa(),
          operacao: getOperacaoLocal(),
          filter: filterPeriodoOrigem
        });

        setTopModalidade(resultTopModalidades.data.data);
        const resultFaturamentoMensal = await api.post('/api/fatMensal/', {
          companyId: getIdEmpresa(),
          operacao: getOperacaoLocal(),
          filter: filterTopImportadores
        });

        const faturamentoMensal = resultFaturamentoMensal.data.data;
        setTopFaturamento({
          meses: faturamentoMensal.map(item => item.mes_abreviado),
          values: faturamentoMensal.map(item => item.valor),
          valoresConvertidos: faturamentoMensal.map(
            item => item.valor_convertido
          )
        });
      }

      const resultPrevChegada = await api.post('/api/chegada/', {
        companyId: getIdEmpresa(),
        operacao: getOperacaoLocal()
      });
      const dataPrevChegada = resultPrevChegada.data.data;
      if (dataPrevChegada && dataPrevChegada.length > 0) {
        setPrevChegada(dataPrevChegada);
        setExisteAtividade(true);
      }
      const resultDeadLineDoc = await api.get(
        '/api/deadlineDoc/' + getIdEmpresa()
      );
      const deadLineDoc = resultDeadLineDoc.data.result;
      // if (deadLineDoc.length > 0) {
      //   setDeadLineDoc(deadLineDoc);
      //   setExisteAtividade(true);
      // }
      const resultDeadLineCarga = await api.get(
        '/api/deadlineCarga/' + getIdEmpresa()
      );
      const deadLineCarga = resultDeadLineCarga.data.result;
      // if (deadLineCarga.length > 0) {
      //   setDeadLineCarga(deadLineCarga);
      //   setExisteAtividade(true);
      // }

      const resultEmbarqueModal = await api.get(
        '/api/deadlineCarga/' + getIdEmpresa()
      );

      const embarqueModal = resultEmbarqueModal.data;
      // if (embarqueModal.length > 0) {
      //   setEmbarquesModal(embarqueModal);
      //   setExisteAtividade(true);
      // }
      setRealizouConsulta(true);
      setRealizouConsultaDados(true);
    };

    await getTipoOperacoes();
    await getLeadTime();
    await getMoedas();
    await getCanais();
    await getMedias();
    // await getOrigens();
    // await getModalidades();
    await getLastEvents();
  };

  const handleDateChange = date => {
    //Pega Data do Período
    setFilterPeriodo(`p.dat_abertura ${date}`);
    setFilterPeriodoOrigem(`p.dat_embarque ${date}`);
  };

  const handleOrigemChange = value => {
    let filtro = '';
    let filtroSub = '';
    if (value.target.value === 'MARITIMO') {
      filtro =
        " AND (p.des_modalidade = 'MARÍTIMO (FCL)' or p.des_modalidade = 'MARÍTIMO (LCL)')";
      filtroSub =
        " AND (p_sub.des_modalidade = 'MARÍTIMO (FCL)' or p_sub.des_modalidade = 'MARÍTIMO (LCL)')";
    } else if (value.target.value === 'COURIER') {
      filtro = " AND (p.des_modalidade = 'COURIER')";
      filtroSub = " AND (p_sub.des_modalidade = 'COURIER')";
    } else if (value.target.value === 'AÉREO') {
      filtro = " AND (p.des_modalidade = 'AÉREO')";
      filtroSub = " AND (p_sub.des_modalidade = 'AÉREO')";
    } else if (value.target.value === 'RODOVIÁRIO') {
      filtro = " AND (p.des_modalidade = 'RODOVIÁRIO')";
      filtroSub = " AND (p_sub.des_modalidade = 'RODOVIÁRIO')";
    } else if (value.target.value === 'BREAK BULK') {
      filtro = " AND (p.des_modalidade = 'BREAK BULK')";
      filtroSub = " AND (p.des_modalidade = 'BREAK BULK')";
    }
    //Pega a operação
    setFilterModalidade(filtro);
    setFilterModalidadeSub(filtroSub);
  };

  const updateDashboard = async () => {
    if (getIdEmpresa() > 0) {
      setRealizouConsultaDados(false);
      let filtro = '';
      let filtroOrigem = '';
      let filtroCanal = '';
      let filtroCanalSub = '';
      if (filterPeriodo !== null) {
        filtro = filterPeriodo;
        filtroOrigem = filterPeriodoOrigem;
        filtroCanal = filterRegistroDI;
        filtroCanalSub = filterRegistroDI;
      }
      if (filterModalidade !== null && filtro !== null) {
        filtro = filtro + filterModalidade;
        filtroCanal = filtroCanal + filterModalidade;
        filtroOrigem = filtroOrigem + filterModalidade;
        filtroCanalSub = filtroCanalSub + filterModalidadeSub;
      }
      if (filterModalidade !== null && filtro === null) {
        filtro = filterModalidade;
        filtroCanal = filterModalidade;
        filtroOrigem = filterModalidade;
        filtroCanalSub = filterModalidadeSub;
      }

      setRealizouConsultaDados(false);
      const getCanais = async () => {
        const result = await api.post('/api/indicadores/', {
          companyId: getIdEmpresa(),
          operacao: getOperacaoLocal(),
          filter: filtroCanal,
          filterSub: filtroCanalSub
        });
        const data = result.data.data;
        if (data.length > 0) {
          setDataCanais(data);
          setCanaisTotal(data[0].total_geral);
        }

        const resultSituacao = await api.post('/api/situacoes/', {
          companyId: getIdEmpresa(),
          operacao: filterOperacao,
          filter: filtro
        });
        setSituacoes(resultSituacao.data.data);
        setQtdSituacoes(resultSituacao.data.total);
        if (getOperacaoLocal() !== '') {
          const resultOrigensGraph = await api.post('/api/origens/', {
            companyId: getIdEmpresa(),
            operacao: filterOperacao,
            filter: filtroOrigem
          });
          setOrigensGraph(resultOrigensGraph.data.data);
        }
      };

      const getMedias = async () => {
        let filterOp =
          filterOperacao === 'EXPORTAÇÃO'
            ? filterTopExportadores
            : filterTopImportadores;
        const resultInd = await api.post('/api/indicadoresMedias/', {
          companyId: getIdEmpresa(),
          operacao: filterOperacao,
          filter: filterOp
        });
        const dataInd = resultInd.data.data;
        if (filterOperacao === 'EXPORTAÇÃO') {
          setMediaRegistro(dataInd.data[0].mediaregistro);
          setMediaLiberacao(dataInd.liberacao[0].mediaLib);
        } else if (filterOperacao === 'IMPORTAÇÃO') {
          // setMediaRegistro(dataInd.data[0].leadtime)
          // setMediaLiberacao(dataInd.data[0].registrodi)
        } else if (filterOperacao === 'AGENCIAMENTO') {
          setTransitTime(dataInd.freetime);
        }
      };

      const getModalidades = async () => {
        const result = await api.get('/api/modalidades/' + getIdEmpresa());
        const data = result.data.data;
        if (data.length > 0) {
          setModalidades(data);
        }
      };

      const getLastEvents = async () => {
        if (
          filterOperacao === 'IMPORTAÇÃO' ||
          filterOperacao === 'AGENCIAMENTO'
        ) {
          const result = await api.post('/api/topFollowPG/', {
            companyId: getIdEmpresa(),
            operacao: filterOperacao
          });
          const data = result.data.data;
          if (data.length > 0) {
            setLastEvents(data);
            setExisteAtividade(true);
          }
          const resultDeadLineCarga = await api.get(
            '/api/demurrage/' + getIdEmpresa()
          );
          const deadLineCarga = resultDeadLineCarga.data.data;
          if (deadLineCarga.length > 0) {
            setDeadLineCarga(deadLineCarga);
            setExisteAtividade(true);
          }

          const resultControleCarga = await api.get(
            '/api/controlecanal/' + getIdEmpresa()
          );
          const controleCanal = resultControleCarga.data.result;
          if (controleCanal.length > 0) {
            setDataControleCanal(controleCanal);
          }

          const resultTopExporters = await api.post('/api/topExportadores/', {
            companyId: getIdEmpresa(),
            operacao: filterOperacao,
            filter: filtro
          });

          const topExporters = resultTopExporters.data.data;
          setTopExportadores({
            importers: topExporters
              .filter(item => item.exportador !== null)
              .map(item => item.exportador),
            values: topExporters
              .filter(item => item.exportador !== null)
              .map(item => item.valor),
            valoresConvertidos: topExporters
              .filter(item => item.exportador !== null)
              .map(item => item.valor_convertido)
          });

          const resultTopModalidades = await api.post('/api/topModalidades/', {
            companyId: getIdEmpresa(),
            operacao: filterOperacao,
            filter: filtro
          });
          setTopModalidade(resultTopModalidades.data.data);

          const resultFaturamentoMensal = await api.post(
            '/api/fatMensalImpo/',
            {
              companyId: getIdEmpresa(),
              operacao: filterOperacao,
              filter: filterTopExportadores
            }
          );

          const faturamentoMensal = resultFaturamentoMensal.data.data;

          setTopFaturamento({
            meses: faturamentoMensal.map(item => item.mes_abreviado),
            values: faturamentoMensal.map(item => item.valor),
            valoresConvertidos: faturamentoMensal.map(
              item => item.valor_convertido
            )
          });
        } else if (filterOperacao === 'EXPORTAÇÃO') {
          const resultExpo = await api.post('/api/topFollowEx/', {
            companyId: getIdEmpresa(),
            operacao: filterOperacao
          });
          const dataExpoDesem = resultExpo.data.desembaraco;
          const dataExpoEmbarque = resultExpo.data.embarque;
          if (dataExpoDesem.length > 0) {
            setLastEventsExDesemb(dataExpoDesem);
            setLastEventsExEmb(resultExpo.data);
            setExisteAtividade(true);
          }
          if (dataExpoEmbarque.length > 0) {
            setLastEventsExEmb(dataExpoEmbarque);
            setExisteAtividade(true);
          }

          const resultTopImporters = await api.post('/api/topImportadores/', {
            companyId: getIdEmpresa(),
            operacao: filterOperacao,
            filter: filtro
          });

          const topImporters = resultTopImporters.data.data;
          setTopImportadores({
            importers: topImporters.map(item => item.importador),
            values: topImporters.map(item => item.valor),
            valoresConvertidos: topImporters.map(item => item.valor_convertido)
          });

          const resultTopModalidades = await api.post('/api/topModalidades/', {
            companyId: getIdEmpresa(),
            operacao: filterOperacao,
            filter: filtro
          });

          setTopModalidade(resultTopModalidades.data.data);
          const resultFaturamentoMensal = await api.post('/api/fatMensal/', {
            companyId: getIdEmpresa(),
            operacao: filterOperacao,
            filter: filtro
          });

          const faturamentoMensal = resultFaturamentoMensal.data.data;
          setTopFaturamento({
            meses: faturamentoMensal.map(item => item.mes_abreviado),
            values: faturamentoMensal.map(item => item.valor),
            valoresConvertidos: faturamentoMensal.map(
              item => item.valor_convertido
            )
          });
        }

        const resultPrevChegada = await api.post('/api/chegada/', {
          companyId: getIdEmpresa(),
          operacao: filterOperacao
        });
        const dataPrevChegada = resultPrevChegada.data.data;
        if (dataPrevChegada.length > 0) {
          setPrevChegada(dataPrevChegada);
          setExisteAtividade(true);
        }
        const resultDeadLineDoc = await api.get(
          '/api/deadlineDoc/' + getIdEmpresa()
        );
        const deadLineDoc = resultDeadLineDoc.data.result;
        if (resultDeadLineDoc.data.length > 0) {
          setDeadLineDoc(deadLineDoc);
          setExisteAtividade(true);
        }
        const resultDeadLineCarga = await api.get(
          '/api/deadlineCarga/' + getIdEmpresa()
        );
        const deadLineCarga = resultDeadLineCarga.data.result;
        if (resultDeadLineCarga.data.length > 0) {
          setDeadLineCarga(deadLineCarga);
          setExisteAtividade(true);
        }

        const resultEmbarqueModal = await api.get(
          '/api/deadlineCarga/' + getIdEmpresa()
        );

        const embarqueModal = resultEmbarqueModal.data;
        if (embarqueModal.length > 0) {
          setEmbarquesModal(embarqueModal);
          setExisteAtividade(true);
        }
        setRealizouConsultaDados(true);
      };
      // await getTipoOperacoes();
      await getCanais();
      await getMedias();
      // await getOrigens();
      // await getModalidades();
      await getLastEvents();
    }
  };

  const handleOperationChange = async value => {
    setFilterOperacao(value.target.value);
  };

  const onDragEnd = result => {
    const { destination, source } = result;

    if (!destination) return;

    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      return;
    }

    const newCards = Array.from(cards);
    const [removed] = newCards.splice(source.index, 1);
    newCards.splice(destination.index, 0, removed);

    setCards(newCards);
  };

  return (
    <>
      {getIdUsuario() === null ? (
        <></>
      ) : (
        <>
          {realizouConsulta ? (
            <>
              <Row className="g-2 mb-2">
                <Col xs={12} sm={7} md={4} lg={4}>
                  <Card className="h-100">
                    <Card.Body>
                      <Row>
                        <Col>
                          <Form.Group>
                            <Form.Label style={{ fontWeight: 'bold' }}>
                              PTAX
                            </Form.Label>
                            <div>
                              {' '}
                              {/* Permite rolagem horizontal se necessário */}
                              <table
                                style={{
                                  fontSize: '0.7rem',
                                  textAlign: 'center',
                                  borderCollapse: 'collapse',
                                  width: '100%' // Garante que a tabela ocupe 100% do espaço disponível
                                }}
                                className="table"
                              >
                                <thead style={{ fontWeight: 'bold' }}>
                                  <tr>
                                    <th>MOEDA</th>
                                    <th>DATA</th>
                                    <th>COMPRA (R$)</th>
                                    <th>VENDA (R$)</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {dataMoedas
                                    .filter(row => row.PtaxCompraValor !== null)
                                    .map(row => (
                                      <tr
                                        key={row.Id}
                                        className="App__ptax__box__table__tr"
                                      >
                                        <td className="App__ptax__box__table__celldados">
                                          {row.moedaid}
                                        </td>
                                        <td className="App__ptax__box__table__celldados">
                                          {row.DataTaxa}
                                        </td>
                                        <td className="App__ptax__box__table__celldados">
                                          {row.PtaxCompraValor}
                                        </td>
                                        <td className="App__ptax__box__table__celldados">
                                          {row.PtaxVendaValor}
                                        </td>
                                      </tr>
                                    ))}
                                </tbody>
                              </table>
                            </div>
                          </Form.Group>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
                <Col xs={12} sm={9} md={9} lg={8}>
                  <PageHeader className="mb-1">
                    <Row className="mb-1">
                      <Col md={3} xxl={3} sm={3}>
                        <Form.Group controlId="releaseDate">
                          <Form.Label>Período</Form.Label>
                          <FilterDate
                            onDateChange={handleDateChange}
                            startDate={dateRange.startDate}
                            endDate={dateRange.endDate}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3} xxl={3} sm={3}>
                        <Form.Group>
                          <Form.Label>Operação</Form.Label>
                          <Form.Select
                            size="sm"
                            value={filterOperacao}
                            onChange={handleOperationChange}
                          >
                            <option value="">Selecione:</option>
                            {tipoOperacoes.map(row => {
                              return (
                                <>
                                  <option value={row.operacao}>
                                    {row.operacao}
                                  </option>
                                </>
                              );
                            })}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={3} xxl={3} sm={3}>
                      <IconButton
                          variant="primary"
                          size="sm"
                          alt="Atualizar"
                          aria-label="Atualizar"
                          onClick={() => updateDashboard()}
                          className="mt-4"
                        >
                          <FontAwesomeIcon icon={faSyncAlt} /> Atualizar
                        </IconButton>
                        {/* <Form.Group>
                          <Form.Label>Modalidade</Form.Label>
                          <Form.Select
                            size="sm"
                            defaultValue={filterOperacao}
                            onChange={handleOrigemChange}
                          >
                            <option value="0">Selecione:</option>
                            {modalidades.map(row => {
                              return (
                                <>
                                  <option value={row.MODALIDADE}>
                                    {row.MODALIDADE}
                                  </option>
                                </>
                              );
                            })}
                            {/* {origens.map(row => {
                      return (
                        <>
                          <option value={row.ORIGEM}>{row.ORIGEM}</option>
                        </>
                      );
                    })} */}
                          {/* </Form.Select>
                          <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                        </Form.Group>  */}
                      </Col>
                      <Col md={2} xxl={2} sm={2}>
                        
                      </Col>
                    </Row>
                  </PageHeader>
                </Col>
              </Row>
            </>
          ) : (
            <></>
          )}
          {getIdEmpresa() > 0 ? (
            <>
              {!realizouConsultaDados ? (
                <>
                  <Flex justifyContent="center">
                    <div className="p-2">
                      <Spinner />
                      <span> Aguarde carregando ...</span>
                    </div>
                  </Flex>
                </>
              ) : (
                <>
                  <Row className="g-2 mb-2">
                    {filterOperacao === 'IMPORTAÇÃO' ? (
                      <>
                        <Col xs={12} sm={6} md={3} lg={3}>
                          <Operations
                            atualizou={realizouConsulta}
                            data={dataSituacoes}
                            totalOp={qtdSituacoes}
                            radius={['100%', '77%']}
                            titulo={'Status'}
                          />
                        </Col>
                      </>
                    ) : filterOperacao === 'EXPORTAÇÃO' ? (
                      <>
                        <Col xs={12} sm={6} md={3} lg={3}>
                          <Operations
                            atualizou={realizouConsulta}
                            data={dataSituacoes}
                            totalOp={qtdSituacoes}
                            radius={['100%', '77%']}
                            titulo={'Status'}
                          />
                        </Col>
                      </>
                    ) : (
                      <>
                        <Col xs={12} sm={6} md={4} lg={4}>
                          <Operations
                            atualizou={realizouConsulta}
                            data={dataSituacoes}
                            totalOp={qtdSituacoes}
                            radius={['100%', '77%']}
                            titulo={'Status'}
                          />
                        </Col>
                      </>
                    )}

                    {filterOperacao === 'IMPORTAÇÃO' ? (
                      <>
                        <Col xs={12} sm={6} md={3} lg={3}>
                          <Operations
                            atualizou={realizouConsulta}
                            data={dataCanais}
                            totalOp={canaisTotal}
                            radius={['100%', '77%']}
                            titulo={'Canais'}
                          />
                        </Col>
                      </>
                    ) : filterOperacao === 'EXPORTAÇÃO' ? (
                      <>
                        <Col xs={12} sm={6} md={2} lg={2}>
                          <Operations
                            atualizou={realizouConsulta}
                            data={dataCanais}
                            totalOp={canaisTotal}
                            radius={['100%', '77%']}
                            titulo={'Canais'}
                          />
                        </Col>
                      </>
                    ) : (
                      <></>
                    )}
                    {filterOperacao === 'IMPORTAÇÃO' ||
                    filterOperacao === 'EXPORTAÇÃO' ? (
                      <>
                        {filterOperacao === 'IMPORTAÇÃO' ? (
                          // <TransitTime data={mediaRegistro} title="Lead Time" />
                          <Col xs={12} sm={6} md={3} lg={3}>
                            <Operations
                              atualizou={realizouConsulta}
                              data={dataLeadTime}
                              totalOp={''}
                              radius={['100%', '77%']}
                              titulo={'Lead Time'}
                            />
                          </Col>
                        ) : filterOperacao === 'EXPORTAÇÃO' ? (
                          <Col xs={12} sm={6} md={3} lg={2}>
                            <TransitTime
                              data={mediaRegistro}
                              title="Tempo Médio Emissão de DU-E"
                            />
                          </Col>
                        ) : (
                          <></>
                        )}

                        {filterOperacao === 'EXPORTAÇÃO' ? (
                          <>
                            <Col xs={12} sm={6} md={3} lg={2}>
                              <TransitTime
                                data={mediaLiberacao}
                                title="Tempo Médio Liberação de DU-E"
                              />
                            </Col>
                          </>
                        ) : (
                          <></>
                        )}
                        {/* <Col xs={12} sm={6} md={3} lg={2}>
                        {filterOperacao === 'IMPORTAÇÃO' ? (
                          <></>
                          // <TransitTime data={mediaLiberacao} title="Tempo Médio Liberação de DI" />
                        ) : filterOperacao === 'EXPORTAÇÃO' ? (
                          <TransitTime data={mediaLiberacao} title="Tempo Médio Liberação de DU-E" />
                        ) : <></>}
                      </Col> */}
                      </>
                    ) : (
                      <>
                        <Col xs={12} sm={6} md={3} lg={3}>
                          <TransitTime
                            data={transitTime}
                            title="Tempo Médio Transit Time"
                          />
                        </Col>
                      </>
                    )}

                    {filterOperacao === 'IMPORTAÇÃO' ||
                    filterOperacao === 'EXPORTAÇÃO' ? (
                      <>
                        <Col xs={12} sm={6} md={3} lg={3}>
                          <Operations
                            atualizou={realizouConsulta}
                            data={dataOrigensGraph}
                            totalOp={''}
                            radius={['100%', '77%']}
                            titulo={
                              filterOperacao === 'IMPORTAÇÃO'
                                ? 'Principais Origens'
                                : 'Principais Destinos'
                            }
                          />
                        </Col>
                      </>
                    ) : (
                      <>
                        <Col xs={12} lg={5}>
                          <Operations
                            atualizou={realizouConsulta}
                            data={dataOrigensGraph}
                            totalOp={''}
                            radius={['100%', '77%']}
                            titulo={'Principais Origens'}
                          />
                        </Col>
                      </>
                    )}
                  </Row>

                  {filterOperacao === 'IMPORTAÇÃO' ||
                  filterOperacao === 'AGENCIAMENTO' ? (
                    <>
                      <span>{existeAtividade}</span>
                      {existeAtividade ? (
                        <>
                          <Row className="g-3 mb-3">
                            <Col lg={7}>
                              <Row className="g-3">
                                <Col xs={12}>
                                  <AtividadesRecentesEmbarque
                                    title="Atividades Recentes"
                                    data={dataLastEvents}
                                    height={'26rem'}
                                    operacao={filterOperacao}
                                  />
                                </Col>
                              </Row>
                            </Col>
                            <Col lg={5}>
                              <Row className="g-3">
                                <Col xs={12}>
                                  <PrevisaoChegada
                                    data={dataPrevChegada}
                                    title="Previsão Chegada"
                                    operacao={filterOperacao}
                                  />
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          {filterOperacao === 'IMPORTAÇÃO' ? (
                            <>
                              <Row className="g-3 mb-3">
                                <Col lg={7}>
                                  <Row className="g-3">
                                    <Col xs={12}>
                                      <ControleCanal
                                        title="Processos em Desembaraço"
                                        data={dataControleCanal}
                                      />
                                    </Col>
                                  </Row>
                                </Col>
                                <Col lg={5}>
                                  <Row className="g-3">
                                    <Col xs={12}>
                                      <TopFaturamento
                                        title={
                                          'Valor Total Importado | Mensal (USD)'
                                        }
                                        meses={dataTopFaturamento.meses}
                                        values={dataTopFaturamento.values}
                                        valoresConvertidos={
                                          dataTopFaturamento.valoresConvertidos
                                        }
                                        heightSize={'18rem'}
                                        height="h-100"
                                      />
                                      {/* <Demurrage
                                        data={deadLineCarga}
                                        title="Demurrage"
                                      /> */}
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            </>
                          ) : (
                            <>1</>
                          )}

                          <Row className="g-3 mb-3">
                            <Col lg={7}>
                              <Row className="g-3">
                                <Col xs={12}>
                                  <TotalImporter
                                    importers={dataTopExportadores.importers}
                                    values={dataTopExportadores.values}
                                    valoresConvertidos={
                                      dataTopExportadores.valoresConvertidos
                                    }
                                    title={
                                      '10 Principais Exportadores | Valor Importado (USD)'
                                    }
                                    heightSize={'18rem'}
                                    height="h-100"
                                  />
                                </Col>
                              </Row>
                            </Col>
                            <Col lg={5}>
                              <Row className="g-3">
                                <Col xs={12}>
                                  <TopModalidade
                                    data={dataTopModalidade}
                                    radius={['100%', '77%']}
                                  />
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          {/* {filterOperacao === 'IMPORTAÇÃO' ? (
                            <>
                              <Row className="g-3 mb-3">
                                <Col lg={7}>
                                  <Row className="g-3">
                                    <Col xs={12}>
                                      <TopFaturamento
                                        title={
                                          'Valor Total Importado | Mensal (USD)'
                                        }
                                        meses={dataTopFaturamento.meses}
                                        values={dataTopFaturamento.values}
                                        valoresConvertidos={
                                          dataTopFaturamento.valoresConvertidos
                                        }
                                        height="h-100"
                                      />
                                    </Col>
                                  </Row>
                                </Col>
                                <Col lg={5}>
                                  <Row className="g-3">
                                    <Col xs={12}></Col>
                                  </Row>
                                </Col>
                              </Row>
                            </>
                          ) : (
                            <></>
                          )} */}
                        </>
                      ) : (
                        <></>
                      )}
                    </>
                  ) : (
                    <>
                      {/*Exportação*/}
                      <div className="parent">
                        <div className="div6">
                          <AtividadesRecentes
                            title="Atividades Recentes | Desembaraço"
                            data={dataLastEventsExDesemb}
                          />
                        </div>
                        <div className="div7">
                          <AtividadesRecentesEmbarque
                            title="Atividades Recentes | Embarque"
                            data={dataLastEventsExEmb}
                            height={'38rem'}
                          />
                        </div>
                        <div className="div1">
                          <PrevisaoChegada
                            data={dataPrevChegada}
                            title="Previsão Saída"
                          />
                        </div>
                        <div className="div2">
                          <DeadLine
                            data={deadLineDoc}
                            title="Deadlines de Draft"
                          />
                        </div>
                        <div className="div3">
                          <DeadLine
                            data={deadLineCarga}
                            title="Deadlines de Carga"
                          />
                        </div>
                        <div className="div4">
                          <TopFaturamento
                            title={'Faturamento Mensal (USD)'}
                            meses={dataTopFaturamento.meses}
                            values={dataTopFaturamento.values}
                            valoresConvertidos={
                              dataTopFaturamento.valoresConvertidos
                            }
                            height="h-80"
                          />
                        </div>
                        <div className="div5">
                          <TotalImporter
                            importers={dataTopImportadores.importers}
                            values={dataTopImportadores.values}
                            valoresConvertidos={
                              dataTopImportadores.valoresConvertidos
                            }
                            title={
                              '10 Principais Importadores | Faturamento (USD)'
                            }
                            heightSize={'18rem'}
                            height="h-80"
                          />
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}
            </>
          ) : (
            <></>
          )}
        </>
      )}
    </>
  );
};

export default Dashboard;
